import useNetwork from '../../hooks/useNetwork';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    creator: network?.id ? {
      $where: {
        networkId: network.id
      }
    } : undefined
  };
};
